import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {CityService} from '@services/city.service';
import {AdService} from '@services/ad.service';
import {CommonService} from '@services/common.service';
import {HttpClient} from '@angular/common/http';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {environment} from '~/environments/environment';
import {MatDialog} from '@angular/material/dialog';
import {AuthenticationService} from '@services/authentification.service';
import {UpgradePlanV2Component} from '@components/popup/upgrade-plan-v2/upgrade-plan-v2.component';
import * as $ from 'jquery';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {LoginFormComponent} from '@components/popup/login-form/login-form.component';
import {QlowerComponent} from '@components/popup/qlower/qlower.component';

export interface Impots {
    amortissement: number;
    annee: number;
    base_imposable: number;
    cash_flow: number;
    charges: number;
    cumul_deficit_benefice: number;
    impot_plus_value: number;
    impot_societes: number;
    impot_societes_avec_revente: number;
    impots_revenus: number;
    prelev_sociaux: number;
    renta_nette_impot: number;
}

@Component({
    selector: 'app-config-impots',
    templateUrl: './config-impots.component.html',
    styleUrls: ['./config-impots.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class ConfigImpotsComponent implements OnInit {

    result: Impots[] = [];
    user: User = Object.assign({}, EMPTY_USER);
    updateRun = null;
    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();
    @Output() extChange = new EventEmitter();

    displayedColumns: string[] = [];
    comp: [] = [];
    data: [] = [];
    loading = false;

    TriVanInstance = null;
    CashFlowInstance = null;
    CompTresoInstance = null;
    EvolCapitalInstance = null;

    warning = [];

    upgradeFormDiffere = new UntypedFormGroup({
        is_differed_total: new UntypedFormControl(false),
    });

    upgradeFormFiscal = new UntypedFormGroup({
        fiscal_choice_cat: new UntypedFormControl(),
        fiscal_choice: new UntypedFormControl(),
    });

    constructor(
        private http: HttpClient,
        public cityService: CityService,
        public adService: AdService,
        public authenticationService: AuthenticationService,
        public dialog: MatDialog,
        public commonService: CommonService) {
    }

    ngOnInit() {
        if (this.favorite.fiscal_choice == 'LMNP reel') {
            this.favorite.fiscal_choice = 'LMNP reel 2025';
        }
        if (this.favorite.fiscal_choice_cat == '') {
            switch (this.favorite.fiscal_choice) {
                case 'Foncier forfait':
                    this.favorite.fiscal_choice_cat = 'Foncier';
                    break;
                case 'Foncier reel':
                    this.favorite.fiscal_choice_cat = 'Foncier';
                    break;
                case 'LMNP forfait':
                    this.favorite.fiscal_choice_cat = 'LMNP';
                    break;
                // case 'LMNP reel':
                //     this.favorite.fiscal_choice_cat = 'LMNP';
                //     break;
                case 'LMNP reel 2025':
                    this.favorite.fiscal_choice_cat = 'LMNP';
                    break;
                case 'LMP - regime reel':
                    this.favorite.fiscal_choice_cat = 'LMP';
                    break;
                case 'LMP - regime forfait':
                    this.favorite.fiscal_choice_cat = 'LMP';
                    break;
                case 'SCI IS':
                    this.favorite.fiscal_choice_cat = 'SCI';
                    break;
                case 'SCI IR':
                    this.favorite.fiscal_choice_cat = 'SCI';
                    break;
                case 'Societe IS':
                    this.favorite.fiscal_choice_cat = 'Societe';
                    break;
                case 'Pinel - foncier reel':
                    this.favorite.fiscal_choice_cat = 'Pinel';
                    break;
                case 'Pinel - micro foncier':
                    this.favorite.fiscal_choice_cat = 'Pinel';
                    break;
                case 'Denormandie - micro foncier':
                    this.favorite.fiscal_choice_cat = 'Denormandie';
                    break;
                case 'Denormandie - foncier reel':
                    this.favorite.fiscal_choice_cat = 'Denormandie';
                    break;
            }
        }

        this.favorite = this.adService.updateValues(this.favorite);

        this.upgradeFormFiscal = new UntypedFormGroup({
            fiscal_choice_cat: new UntypedFormControl(this.favorite.fiscal_choice_cat),
            fiscal_choice: new UntypedFormControl(this.favorite.fiscal_choice),
        });

        this.user = this.authenticationService.currentUser;
        this.edit(null);

        this.extChange.subscribe(data => {
            this.callImpot();
        });
    }

    toogleSelling(selling) {
        this.favorite.selling = selling;
        this.favoriteChange.emit();
    }

    changeView() {
        $('#bilanComptable').removeClass('minimize');
        this.setColums();
        this.favoriteChange.emit();
    }

    setColums() {
        let colums = this.favorite.fiscal_choice;
        if (colums == 'Societe IS') {
            colums = 'SCI IS';
        }

        if (this.favorite.fiscal_detailed_view == true) {
            if (this.favorite.selling == false) {
                this.displayedColumns = this.data[colums].cols;
            } else {
                this.displayedColumns = this.data[colums].cols_revente;
            }
        } else {
            if (this.favorite.selling == false) {
                this.displayedColumns = this.data[colums].cols_simple;
            } else {
                this.displayedColumns = this.data[colums].cols_revente_simple;
            }
        }
    }

    openQlower() {
        const dialogRef = this.dialog.open(QlowerComponent, {
            width: '520px',
        });
    }

    upgradeFields(fields) {
        if (fields == 'differe') {
            this.favorite.credit_differed_duration = 0;
            this.favorite.works_duration = 0;
            this.favorite.rent_before_work = 0;
            this.favorite.is_differed_total = false;
            this.upgradeFormDiffere.controls['is_differed_total'].setValue(false);

            if (!this.authenticationService.isLogin) {
                const dialogRef = this.dialog.open(LoginFormComponent, {
                    width: '550px',
                    data: {
                        disableClose: false
                    },
                });
            } else {
                const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                    width: '520px',
                    data: {visuel: 'assets/upgrade/differe.png', plan: 'Expert', feature: 'Différé de crédit immobilier'}
                });
            }
            return;
        }

        if (fields === 'selling') {
            this.favorite.selling_price = this.favorite.ad.price;
            this.favorite.selling_year = 0;
            if (!this.authenticationService.isLogin) {
                const dialogRef = this.dialog.open(LoginFormComponent, {
                    width: '550px',
                    data: {
                        disableClose: false
                    },
                });
            } else {
                const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                    width: '520px',
                    data: {visuel: 'assets/upgrade/differe.png', plan: 'Essentiel', feature: 'Imposition à la revente'}
                });
            }
            return;
        }

        if (fields === 'fiscal_choice' || fields === 'fiscal_choice_cat') {
            if (fields === 'fiscal_choice_cat') {
                switch (this.upgradeFormFiscal.controls['fiscal_choice_cat'].value) {
                    case 'Foncier':
                        this.upgradeFormFiscal.controls['fiscal_choice'].setValue('Foncier forfait');
                        break;
                    case 'Jeanbrun':
                        this.upgradeFormFiscal.controls['fiscal_choice'].setValue('Jeanbrun - intermediaire');
                        break;
                    case 'LMNP':
                        this.upgradeFormFiscal.controls['fiscal_choice'].setValue('LMNP forfait');
                        break;
                    case 'LMP':
                        this.upgradeFormFiscal.controls['fiscal_choice'].setValue('LMP - regime reel');
                        break;
                    case 'SCI':
                        this.upgradeFormFiscal.controls['fiscal_choice'].setValue('SCI IS');
                        break;
                    case 'Societe':
                        this.upgradeFormFiscal.controls['fiscal_choice'].setValue('Societe IS');
                        break;
                    case 'Pinel':
                        this.upgradeFormFiscal.controls['fiscal_choice'].setValue('Pinel - foncier reel');
                        break;
                    case 'Denormandie':
                        this.upgradeFormFiscal.controls['fiscal_choice'].setValue('Denormandie - micro foncier');
                        break;
                }
            }

            if ((this.upgradeFormFiscal.controls['fiscal_choice'].value == 'LMP - regime reel' || this.upgradeFormFiscal.controls['fiscal_choice'].value == 'Societe IS') && !this.authenticationService.isAllowed('expert')) {
                if (!this.authenticationService.isLogin) {
                    const dialogRef = this.dialog.open(LoginFormComponent, {
                        width: '550px',
                        data: {
                            disableClose: false
                        },
                    });
                } else {
                    const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                        width: '520px',
                        data: {visuel: 'assets/upgrade/is.png', plan: 'Expert', feature: 'Fiscalité en ' + this.upgradeFormFiscal.controls['fiscal_choice'].value}
                    });
                }
                this.upgradeFormFiscal.controls['fiscal_choice'].setValue(this.favorite.fiscal_choice);
                this.upgradeFormFiscal.controls['fiscal_choice_cat'].setValue(this.favorite.fiscal_choice_cat);
                return;
            } else if ((
                this.upgradeFormFiscal.controls['fiscal_choice'].value == 'SCI IS' ||
                this.upgradeFormFiscal.controls['fiscal_choice'].value == 'Societe IS' ||
                this.upgradeFormFiscal.controls['fiscal_choice'].value == 'Pinel - foncier reel' ||
                this.upgradeFormFiscal.controls['fiscal_choice'].value == 'Pinel - micro foncier' ||
                this.upgradeFormFiscal.controls['fiscal_choice'].value == 'Denormandie - micro foncier' ||
                this.upgradeFormFiscal.controls['fiscal_choice'].value == 'Denormandie - foncier reel'
            ) && !this.authenticationService.isAllowed('essentiel')) {
                if (!this.authenticationService.isLogin) {
                    const dialogRef = this.dialog.open(LoginFormComponent, {
                        width: '550px',
                        data: {
                            disableClose: false
                        },
                    });
                } else {
                    const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                        width: '520px',
                        data: {visuel: 'assets/upgrade/is.png', plan: 'Essentiel', feature: 'Fiscalité en ' + this.upgradeFormFiscal.controls['fiscal_choice'].value}
                    });
                }
                this.upgradeFormFiscal.controls['fiscal_choice'].setValue(this.favorite.fiscal_choice);
                this.upgradeFormFiscal.controls['fiscal_choice_cat'].setValue(this.favorite.fiscal_choice_cat);
                return;
            } else if (this.upgradeFormFiscal.controls['fiscal_choice'].value != 'Foncier forfait' && (this.user.pro_plan == '' && (this.user.plan == 'trial' || this.user.plan == ''))) {
                if (!this.authenticationService.isLogin) {
                    const dialogRef = this.dialog.open(LoginFormComponent, {
                        width: '550px',
                        data: {
                            disableClose: false
                        },
                    });
                } else {
                    const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                        width: '520px',
                        data: {visuel: 'assets/upgrade/is.png', plan: 'Essentiel', feature: 'Fiscalité en ' + this.upgradeFormFiscal.controls['fiscal_choice'].value}
                    });
                }
                this.upgradeFormFiscal.controls['fiscal_choice'].setValue(this.favorite.fiscal_choice);
                this.upgradeFormFiscal.controls['fiscal_choice_cat'].setValue(this.favorite.fiscal_choice_cat);
                return;
            } else {
                this.favorite.fiscal_choice = this.upgradeFormFiscal.controls['fiscal_choice'].value;
                this.favorite.fiscal_choice_cat = this.upgradeFormFiscal.controls['fiscal_choice_cat'].value;

                this.edit();
            }
        }
    }

    edit(fields = '') {
        this.callImpot();
        this.favoriteChange.emit();
    }

    tauxAnnu(taux, annee) {
        return Math.pow(1 + taux, 1 / annee) - 1;
    }

    showAll() {
        $('.previewBlock').removeClass('previewBlock');
    }

    // Graphique comparaison des régimes fiscaux
    options = {
        legend: {
            orient: 'vertical',
            right: 'right',
            selected: {},
        },
        tooltip: {},
        dataset: {
            source: []
        },
        xAxis: [
            {type: 'category', gridIndex: 0, data: ['']},
            {type: 'category', gridIndex: 1, data: ['']},
            {type: 'category', gridIndex: 2, data: ['']}
        ],
        yAxis: [
            {
                gridIndex: 0, axisLabel: {
                    formatter: '{value} €'
                }
            },
            {
                gridIndex: 1, axisLabel: {
                    formatter: '{value} €'
                }
            },
            {
                gridIndex: 2, axisLabel: {
                    formatter: '{value} %'
                }
            }
        ],
        grid: [
            {left: '5%', right: '73%'}, // 5 to 27
            {left: '35%', right: '43%'}, // 35 to 57
            {left: '63%', right: '15%'}, // 63 to 85
        ],
        series: []
    };

    // Graphique évolution du cash flow
    options_CF = {
        tooltip: {
            trigger: 'item',
            formatter: params => {
                let lib = 'Année ' + params.name + ' <br/>' + '<span style="font-size:24px; color: ' + params.color + '">• </span>' + params.seriesName + ' : ' + params.value + '€';
                return lib;
            },
            axisPointer: {
                type: 'cross',
                crossStyle: {
                    color: '#999'
                }
            }
        },
        legend: {
            orient: 'vertical',
            right: 'right',
        },
        xAxis: [
            {
                type: 'category',
                name: 'Année',
                nameLocation: 'center',
                nameTextStyle: {
                    align: 'center',
                    lineHeight: 50,
                    fontWeight: 'bold',
                    fontSize: 15
                },
                data: [],
                axisPointer: {}
            }
        ],
        yAxis: [
            {
                type: 'value',
                // name: 'Loyers et charges',
                axisLabel: {
                    formatter: '{value} €'
                }
            },
        ],
        grid: [
            {top: '1%', left: '5%', right: '12%'},
        ],
        series: []
    };

    // Graphique comparaison de la trésorerie
    options_Comp_Treso = {
        tooltip: {
            trigger: 'item',
            formatter: params => {
                let lib = 'Année ' + params.name + ' <br/>' + '<span style="font-size:24px; color: ' + params.color + '">• </span>' + params.seriesName + ' : ' + params.value + '€';
                return lib;
            },
        },
        legend: {
            orient: 'vertical',
            right: 'right',
            selected: {}
        },
        xAxis: [
            {
                type: 'category',
                name: 'Année',
                nameLocation: 'center',
                nameTextStyle: {
                    align: 'center',
                    lineHeight: 50,
                    fontWeight: 'bold',
                    fontSize: 15
                },
                data: [],
            }
        ],
        yAxis: [
            {
                type: 'value',
                axisLabel: {
                    formatter: '{value} €'
                },
            },
        ],
        grid: [
            {top: '1%', left: '5%', right: '24%'},
        ],
        series: []
    };

    // Graphique Evolution du capital net
    options_Evol_Capital = {
        tooltip: {
            trigger: 'item',
            formatter: params => {
                let lib = 'Année ' + params.name + ' <br/>' + '<span style="font-size:24px; color: ' + params.color + '">• </span>' + params.seriesName + ' : ' + params.value + '€';
                return lib;
            },
        },
        legend: {
            orient: 'vertical',
            right: 'right',
        },
        xAxis: [
            {
                type: 'category',
                name: 'Année',
                nameLocation: 'center',
                nameTextStyle: {
                    align: 'center',
                    lineHeight: 50,
                    fontWeight: 'bold',
                    fontSize: 15
                },
                data: []
            }
        ],
        yAxis: [
            {
                type: 'value',
                axisLabel: {
                    formatter: '{value} €'
                }
            },
        ],
        grid: [
            {top: '1%', left: '5%', right: '12%'},
        ],
        series: []
    };

    callImpot() {
        this.loading = true;
        this.warning = [];
        this.result = [];

        this.favorite = this.adService.cleanInput(this.favorite);
        this.favorite = this.adService.updateValues(this.favorite);

        const fav = this.adService.cleanForImpot(this.favorite, this.user);
        if (fav.fiscal_choice !== '' && fav.price > 0 && fav.amount_rent > 0) {

            if (this.updateRun != null) {
                clearTimeout(this.updateRun);
            }

            this.updateRun = setTimeout(() => {
                // Prevent fail from API but useless var
                fav.is_credit_differed = false;
                this.http.post<any>(environment.impotUrl, fav)
                    .subscribe(data => {
                        this.data = data;
                        if (data.warning !== undefined && data.warning[fav.fiscal_choice] !== undefined) {
                            this.warning = data.warning[fav.fiscal_choice].split(';');
                        }

                        if (data[fav.fiscal_choice] !== undefined) {

                            // Graphique compraison des régimes fiscaux
                            if (fav.selling == true) {
                                this.result = data[fav.fiscal_choice].impots.slice(0, fav.selling_year);

                                this.options_CF.xAxis[0].data = Array.from({length: fav.selling_year}, (_, i) => i + 1);
                                this.options_Comp_Treso.xAxis[0].data = Array.from({length: fav.selling_year}, (_, i) => i + 1);
                                this.options_Evol_Capital.xAxis[0].data = Array.from({length: fav.selling_year}, (_, i) => i + 1);
                                if (this.favorite.duration < this.favorite.selling_year) {
                                    this.options_Evol_Capital.xAxis[0].data = Array.from({length: this.favorite.duration}, (_, i) => i + 1);
                                }
                                if (fav.selling_year <= 15) {
                                    this.showAll();
                                }
                            } else {
                                this.result = data[fav.fiscal_choice].impots;

                                this.options_CF.xAxis[0].data = Array.from({length: 30}, (_, i) => i + 1);
                                this.options_Comp_Treso.xAxis[0].data = Array.from({length: 30}, (_, i) => i + 1);
                                this.options_Evol_Capital.xAxis[0].data = Array.from({length: this.favorite.duration}, (_, i) => i + 1);
                            }
                            this.setColums();

                            this.comp = data.comparatif;

                            // Graphique compraison des régimes fiscaux
                            this.options.series = [
                                // Barchart Enrichissement
                                {
                                    type: 'bar',
                                    color: '#91D6F7',
                                    xAxisIndex: 0,
                                    yAxisIndex: 0,
                                    name: 'Foncier Micro foncier',
                                    data: [Math.round(this.comp['Foncier forfait'].enrichment)]
                                }, {
                                    type: 'bar',
                                    color: '#43AFE3',
                                    xAxisIndex: 0,
                                    yAxisIndex: 0,
                                    name: 'Foncier Régime réel / SCI à l\'IR',
                                    data: [Math.round(this.comp['Foncier reel'].enrichment)]
                                }, {
                                    type: 'bar',
                                    color: '#9CE16F',
                                    xAxisIndex: 0,
                                    yAxisIndex: 0,
                                    name: 'LMNP Micro BIC',
                                    data: [Math.round(this.comp['LMNP forfait'].enrichment)]
                                }, {
                                    type: 'bar',
                                    color: '#5CB026',
                                    xAxisIndex: 0,
                                    yAxisIndex: 0,
                                    name: 'LMNP Régime réel',
                                    data: [Math.round(this.comp['LMNP reel 2025'].enrichment)]
                                }, {
                                    type: 'bar',
                                    color: '#346911',
                                    xAxisIndex: 0,
                                    yAxisIndex: 0,
                                    name: 'LMP Régime réel',
                                    data: [Math.round(this.comp['LMP - regime reel'].enrichment)]
                                }, {
                                    type: 'bar',
                                    color: '#FFCA60',
                                    xAxisIndex: 0,
                                    yAxisIndex: 0,
                                    name: 'SCI à l\'IS',
                                    data: [Math.round(this.comp['SCI IS'].enrichment)]
                                }, {
                                    type: 'bar',
                                    color: '#a491f7',
                                    xAxisIndex: 0,
                                    yAxisIndex: 0,
                                    name: 'Pinel Foncier réel',
                                    data: [Math.round(this.comp['Pinel - foncier reel'].enrichment)]
                                }, {
                                    type: 'bar',
                                    color: '#6349d5',
                                    xAxisIndex: 0,
                                    yAxisIndex: 0,
                                    name: 'Pinel Micro foncier',
                                    data: [Math.round(this.comp['Pinel - micro foncier'].enrichment)]
                                }, {
                                    type: 'bar',
                                    color: '#f7e991',
                                    xAxisIndex: 0,
                                    yAxisIndex: 0,
                                    name: 'Denormandie Foncier réel',
                                    data: [Math.round(this.comp['Denormandie - foncier reel'].enrichment)]
                                }, {
                                    type: 'bar',
                                    color: '#efd533',
                                    xAxisIndex: 0,
                                    yAxisIndex: 0,
                                    name: 'Denormandie Micro foncier',
                                    data: [Math.round(this.comp['Denormandie - micro foncier'].enrichment)]
                                },

                                // Barchart VAN
                                {
                                    type: 'bar',
                                    color: '#91D6F7',
                                    xAxisIndex: 1,
                                    yAxisIndex: 1,
                                    name: 'Foncier Micro foncier',
                                    data: [Math.round(this.comp['Foncier forfait'].VAN)]
                                }, {
                                    type: 'bar',
                                    color: '#43AFE3',
                                    xAxisIndex: 1,
                                    yAxisIndex: 1,
                                    name: 'Foncier Régime réel / SCI à l\'IR',
                                    data: [Math.round(this.comp['Foncier reel'].VAN)]
                                }, {
                                    type: 'bar',
                                    color: '#9CE16F',
                                    xAxisIndex: 1,
                                    yAxisIndex: 1,
                                    name: 'LMNP Micro BIC',
                                    data: [Math.round(this.comp['LMNP forfait'].VAN)]
                                },{
                                    type: 'bar',
                                    color: '#5CB026',
                                    xAxisIndex: 1,
                                    yAxisIndex: 1,
                                    name: 'LMNP Régime réel',
                                    data: [Math.round(this.comp['LMNP reel 2025'].VAN)]
                                }, {
                                    type: 'bar',
                                    color: '#346911',
                                    xAxisIndex: 1,
                                    yAxisIndex: 1,
                                    name: 'LMP Régime réel',
                                    data: [Math.round(this.comp['LMP - regime reel'].VAN)]
                                }, {
                                    type: 'bar',
                                    color: '#FFCA60',
                                    xAxisIndex: 1,
                                    yAxisIndex: 1,
                                    name: 'SCI à l\'IS',
                                    data: [Math.round(this.comp['SCI IS'].VAN)]
                                }, {
                                    type: 'bar',
                                    color: '#a491f7',
                                    xAxisIndex: 1,
                                    yAxisIndex: 1,
                                    name: 'Pinel Foncier réel',
                                    data: [Math.round(this.comp['Pinel - foncier reel'].VAN)]
                                }, {
                                    type: 'bar',
                                    color: '#6349d5',
                                    xAxisIndex: 1,
                                    yAxisIndex: 1,
                                    name: 'Pinel Micro foncier',
                                    data: [Math.round(this.comp['Pinel - micro foncier'].VAN)]
                                }, {
                                    type: 'bar',
                                    color: '#f7e991',
                                    xAxisIndex: 1,
                                    yAxisIndex: 1,
                                    name: 'Denormandie Foncier réel',
                                    data: [Math.round(this.comp['Denormandie - foncier reel'].VAN)]
                                }, {
                                    type: 'bar',
                                    color: '#efd533',
                                    xAxisIndex: 1,
                                    yAxisIndex: 1,
                                    name: 'Denormandie Micro foncier',
                                    data: [Math.round(this.comp['Denormandie - micro foncier'].VAN)]
                                },

                                // Barchart TRI
                                {
                                    type: 'bar',
                                    color: '#91D6F7',
                                    xAxisIndex: 2,
                                    yAxisIndex: 2,
                                    name: 'Foncier Micro foncier',
                                    data: [Math.round(this.comp['Foncier forfait'].TRI * 10000) / 100]
                                }, {
                                    type: 'bar',
                                    color: '#43AFE3',
                                    xAxisIndex: 2,
                                    yAxisIndex: 2,
                                    name: 'Foncier Régime réel / SCI à l\'IR',
                                    data: [Math.round(this.comp['Foncier reel'].TRI * 10000) / 100]
                                }, {
                                    type: 'bar',
                                    color: '#9CE16F',
                                    xAxisIndex: 2,
                                    yAxisIndex: 2,
                                    name: 'LMNP Micro BIC',
                                    data: [Math.round(this.comp['LMNP forfait'].TRI * 10000) / 100]
                                },  {
                                    type: 'bar',
                                    color: '#5CB026',
                                    xAxisIndex: 2,
                                    yAxisIndex: 2,
                                    name: 'LMNP Régime réel',
                                    data: [Math.round(this.comp['LMNP reel 2025'].TRI * 10000) / 100]
                                }, {
                                    type: 'bar',
                                    color: '#346911',
                                    xAxisIndex: 2,
                                    yAxisIndex: 2,
                                    name: 'LMP Régime réel',
                                    data: [Math.round(this.comp['LMP - regime reel'].TRI * 10000) / 100]
                                }, {
                                    type: 'bar',
                                    color: '#FFCA60',
                                    xAxisIndex: 2,
                                    yAxisIndex: 2,
                                    name: 'SCI à l\'IS',
                                    data: [Math.round(this.comp['SCI IS'].TRI * 10000) / 100]
                                }, {
                                    type: 'bar',
                                    color: '#a491f7',
                                    xAxisIndex: 2,
                                    yAxisIndex: 2,
                                    name: 'Pinel Foncier réel',
                                    data: [Math.round(this.comp['Pinel - foncier reel'].TRI * 10000) / 100]
                                }, {
                                    type: 'bar',
                                    color: '#6349d5',
                                    xAxisIndex: 2,
                                    yAxisIndex: 2,
                                    name: 'Pinel Micro foncier',
                                    data: [Math.round(this.comp['Pinel - micro foncier'].TRI * 10000) / 100]
                                }, {
                                    type: 'bar',
                                    color: '#f7e991',
                                    xAxisIndex: 2,
                                    yAxisIndex: 2,
                                    name: 'Denormandie Foncier réel',
                                    data: [Math.round(this.comp['Denormandie - foncier reel'].TRI * 10000) / 100]
                                }, {
                                    type: 'bar',
                                    color: '#efd533',
                                    xAxisIndex: 2,
                                    yAxisIndex: 2,
                                    name: 'Denormandie Micro foncier',
                                    data: [Math.round(this.comp['Denormandie - micro foncier'].TRI * 10000) / 100]
                                },
                            ];

                            // Graphique évolution du Cash Flow
                            const data_charges = [];
                            const data_loyers = [];
                            const data_CF = [];
                            const data_PS = [];
                            const data_impots = [];
                            const data_credit = [];
                            const data_CS = [];

                            Object.keys(this.result).forEach(keys => {
                                data_CF.push(Math.round(this.result[keys].cash_flow));
                                data_loyers.push(Math.round(this.result[keys].loyers_percus));
                                data_PS.push(Math.round(this.result[keys].prelev_sociaux));
                                data_credit.push(Math.round(this.result[keys].annuite));
                                if (fav.fiscal_choice == 'SCI IS') {
                                    data_impots.push(Math.round(this.result[keys].impot_societes));
                                    data_charges.push(Math.round(-(this.result[keys].loyers_percus - this.result[keys].cash_flow + this.result[keys].impot_societes + this.result[keys].annuite)));
                                } else if (fav.fiscal_choice == 'LMP - regime reel') {
                                    data_impots.push(Math.round(this.result[keys].impots_revenus));
                                    data_charges.push(Math.round(-(this.result[keys].loyers_percus - this.result[keys].cash_flow + this.result[keys].prelev_sociaux + this.result[keys].impots_revenus + this.result[keys].annuite + this.result[keys].cotisations_sociales)));
                                    data_CS.push(Math.round(this.result[keys].cotisations_sociales));
                                } else {
                                    data_impots.push(Math.round(this.result[keys].impots_revenus));
                                    data_charges.push(Math.round(-(this.result[keys].loyers_percus - this.result[keys].cash_flow + this.result[keys].prelev_sociaux + this.result[keys].impots_revenus + this.result[keys].annuite)));
                                }
                            });

                            var series = [
                                {
                                    type: 'bar',
                                    name: 'Loyers',
                                    color: '#78C447',
                                    stack: 'stack',
                                    barWidth: 20,
                                    data: data_loyers,
                                    lineStyle: {},
                                    symbolSize: 0,
                                },
                                {
                                    type: 'bar',
                                    name: 'Charges',
                                    color: '#9C9C9C',
                                    stack: 'stack',
                                    barWidth: 20,
                                    data: data_charges,
                                },
                                {
                                    type: 'bar',
                                    name: 'Crédit',
                                    color: '#FABB3D',
                                    stack: 'stack',
                                    barWidth: 20,
                                    data: data_credit,
                                },
                                {
                                    type: 'bar',
                                    name: 'Impôts',
                                    color: '#EB2D2D',
                                    stack: 'stack',
                                    barWidth: 20,
                                    data: data_impots,
                                },
                                {
                                    type: 'bar',
                                    name: 'Prélèvements sociaux',
                                    color: '#FF7777',
                                    stack: 'stack',
                                    barWidth: 20,
                                    data: data_PS,
                                },
                            ]

                            if (fav.fiscal_choice == 'LMP - regime reel') {
                                series.push(
                                    {
                                        type: 'bar',
                                        name: 'Cotisations sociales',
                                        color: '#e7abab',
                                        stack: 'stack',
                                        barWidth: 20,
                                        data: data_CS,
                                    })
                            }

                            series.push(
                            {
                                type: 'line',
                                lineStyle: {
                                    width: 3
                                },
                                symbolSize: 12,
                                name: 'Cash-Flow',
                                color: '#67C2EF',
                                data: data_CF,
                                stack: '',
                                barWidth: 0,
                            });
                            // Graphique évolution du Cash Flow
                            this.options_CF.series = series;

                            // Graphique comparaison de la trésorerie
                            const data_CF_SCIIS = [];
                            const data_TC_SCIIS = [];
                            Object.keys(data['SCI IS'].impots).forEach(keys => {
                                data_CF_SCIIS.push(Math.round(data['SCI IS'].impots[keys].cash_flow_revente));
                                data_TC_SCIIS.push(Math.round(data['SCI IS'].impots[keys].treso_revente));
                            });

                            const data_CF_LMPREEL = [];
                            const data_TC_LMPREEL = [];
                            Object.keys(data['LMP - regime reel'].impots).forEach(keys => {
                                data_CF_LMPREEL.push(Math.round(data['LMP - regime reel'].impots[keys].cash_flow_revente));
                                data_TC_LMPREEL.push(Math.round(data['LMP - regime reel'].impots[keys].treso_revente));
                            });

                            const data_CF_LMNPREEL2025 = [];
                            const data_TC_LMNPREEL2025 = [];
                            Object.keys(data['LMNP reel 2025'].impots).forEach(keys => {
                                data_CF_LMNPREEL2025.push(Math.round(data['LMNP reel 2025'].impots[keys].cash_flow_revente));
                                data_TC_LMNPREEL2025.push(Math.round(data['LMNP reel 2025'].impots[keys].treso_revente));
                            });

                            const data_CF_LMNPFORFAIT = [];
                            const data_TC_LMNPFORFAIT = [];
                            Object.keys(data['LMNP forfait'].impots).forEach(keys => {
                                data_CF_LMNPFORFAIT.push(Math.round(data['LMNP forfait'].impots[keys].cash_flow_revente));
                                data_TC_LMNPFORFAIT.push(Math.round(data['LMNP forfait'].impots[keys].treso_revente));
                            });

                            const data_CF_FONCIERREEL = [];
                            const data_TC_FONCIERREEL = [];
                            Object.keys(data['Foncier reel'].impots).forEach(keys => {
                                data_CF_FONCIERREEL.push(Math.round(data['Foncier reel'].impots[keys].cash_flow_revente));
                                data_TC_FONCIERREEL.push(Math.round(data['Foncier reel'].impots[keys].treso_revente));
                            });

                            const data_CF_FONCIERFORFAIT = [];
                            const data_TC_FONCIERFORFAIT = [];
                            Object.keys(data['Foncier forfait'].impots).forEach(keys => {
                                data_CF_FONCIERFORFAIT.push(Math.round(data['Foncier forfait'].impots[keys].cash_flow_revente));
                                data_TC_FONCIERFORFAIT.push(Math.round(data['Foncier forfait'].impots[keys].treso_revente));
                            });

                            const data_CF_PINELFONCIERREEL = [];
                            const data_TC_PINELFONCIERREEL = [];
                            Object.keys(data['Pinel - foncier reel'].impots).forEach(keys => {
                                data_CF_PINELFONCIERREEL.push(Math.round(data['Pinel - foncier reel'].impots[keys].cash_flow_revente));
                                data_TC_PINELFONCIERREEL.push(Math.round(data['Pinel - foncier reel'].impots[keys].treso_revente));
                            });

                            const data_CF_PINELFONCIERFORFAIT = [];
                            const data_TC_PINELFONCIERFORFAIT = [];
                            Object.keys(data['Pinel - micro foncier'].impots).forEach(keys => {
                                data_CF_PINELFONCIERFORFAIT.push(Math.round(data['Pinel - micro foncier'].impots[keys].cash_flow_revente));
                                data_TC_PINELFONCIERFORFAIT.push(Math.round(data['Pinel - micro foncier'].impots[keys].treso_revente));
                            });

                            const data_CF_DENORMANDIEFORFAIT = [];
                            const data_TC_DENORMANDIEFORFAIT = [];
                            Object.keys(data['Denormandie - micro foncier'].impots).forEach(keys => {
                                data_CF_DENORMANDIEFORFAIT.push(Math.round(data['Denormandie - micro foncier'].impots[keys].cash_flow_revente));
                                data_TC_DENORMANDIEFORFAIT.push(Math.round(data['Denormandie - micro foncier'].impots[keys].treso_revente));
                            });

                            const data_CF_DENORMANDIEREEL = [];
                            const data_TC_DENORMANDIEREEL = [];
                            Object.keys(data['Denormandie - foncier reel'].impots).forEach(keys => {
                                data_CF_DENORMANDIEREEL.push(Math.round(data['Denormandie - foncier reel'].impots[keys].cash_flow_revente));
                                data_TC_DENORMANDIEREEL.push(Math.round(data['Denormandie - foncier reel'].impots[keys].treso_revente));
                            });

                            this.options_Comp_Treso.series = [
                                {
                                    type: 'bar',
                                    name: 'Cash-Flow Foncier Micro foncier',
                                    color: '#91D6F7',
                                    data: data_CF_FONCIERFORFAIT
                                },
                                {
                                    type: 'line',
                                    lineStyle: {
                                        width: 3
                                    },
                                    symbolSize: 12,
                                    name: 'Trésorerie cumulée Foncier Micro foncier',
                                    color: '#91D6F7',
                                    data: data_TC_FONCIERFORFAIT
                                },
                                {
                                    type: 'bar',
                                    name: 'Cash-Flow Foncier Régime réel / SCI à l\'IR',
                                    color: '#43AFE3',
                                    // barWidth: 20,
                                    data: data_CF_FONCIERREEL
                                },
                                {
                                    type: 'line',
                                    lineStyle: {
                                        width: 3
                                    },
                                    symbolSize: 12,
                                    name: 'Trésorerie cumulée Foncier Régime réel / SCI à l\'IR',
                                    color: '#43AFE3',
                                    data: data_TC_FONCIERREEL
                                },
                                {
                                    type: 'bar',
                                    name: 'Cash-Flow LMNP Micro BIC',
                                    color: '#9CE16F',
                                    // barWidth: 20,
                                    data: data_CF_LMNPFORFAIT
                                },
                                {
                                    type: 'line',
                                    lineStyle: {
                                        width: 3
                                    },
                                    symbolSize: 12,
                                    name: 'Trésorerie cumulée LMNP Micro BIC',
                                    color: '#9CE16F',
                                    data: data_TC_LMNPFORFAIT
                                },
                                {
                                    type: 'bar',
                                    name: 'Cash-Flow LMNP Régime réel',
                                    color: '#8dea51',
                                    // barWidth: 20,
                                    data: data_CF_LMNPREEL2025
                                },
                                {
                                    type: 'line',
                                    lineStyle: {
                                        width: 3
                                    },
                                    symbolSize: 12,
                                    name: 'Trésorerie cumulée LMNP Régime réel',
                                    color: '#8dea51',
                                    data: data_TC_LMNPREEL2025
                                },
                                {
                                    type: 'bar',
                                    name: 'Cash-Flow LMP Régime réel',
                                    color: '#346911',
                                    // barWidth: 20,
                                    data: data_CF_LMPREEL
                                },
                                {
                                    type: 'line',
                                    lineStyle: {
                                        width: 3
                                    },
                                    symbolSize: 12,
                                    name: 'Trésorerie cumulée LMP Régime réel',
                                    color: '#346911',
                                    data: data_TC_LMPREEL
                                },
                                {
                                    type: 'bar',
                                    name: 'Cash-Flow SCI IS',
                                    color: '#FFCA60',
                                    // barWidth: 20,
                                    data: data_CF_SCIIS
                                },
                                {
                                    type: 'line',
                                    lineStyle: {
                                        width: 3
                                    },
                                    symbolSize: 12,
                                    name: 'Trésorerie cumulée SCI IS',
                                    color: '#FFCA60',
                                    data: data_TC_SCIIS
                                },

                                {
                                    type: 'bar',
                                    name: 'Cash-Flow Pinel Foncier réel',
                                    color: '#a491f7',
                                    // barWidth: 20,
                                    data: data_CF_PINELFONCIERREEL
                                },
                                {
                                    type: 'line',
                                    lineStyle: {
                                        width: 3
                                    },
                                    symbolSize: 12,
                                    name: 'Trésorerie cumulée Pinel Foncier réel',
                                    color: '#a491f7',
                                    data: data_TC_PINELFONCIERREEL
                                },
                                {
                                    type: 'bar',
                                    name: 'Cash-Flow Pinel Micro foncier',
                                    color: '#6349d5',
                                    // barWidth: 20,
                                    data: data_CF_PINELFONCIERFORFAIT
                                },
                                {
                                    type: 'line',
                                    lineStyle: {
                                        width: 3
                                    },
                                    symbolSize: 12,
                                    name: 'Trésorerie cumulée Pinel Micro foncier',
                                    color: '#6349d5',
                                    data: data_TC_PINELFONCIERFORFAIT
                                },
                                {
                                    type: 'bar',
                                    name: 'Cash-Flow Denormandie Micro foncier',
                                    color: '#f7e991',
                                    // barWidth: 20,
                                    data: data_CF_DENORMANDIEFORFAIT
                                },
                                {
                                    type: 'line',
                                    lineStyle: {
                                        width: 3
                                    },
                                    symbolSize: 12,
                                    name: 'Trésorerie cumulée Denormandie Micro foncier',
                                    color: '#f7e991',
                                    data: data_TC_DENORMANDIEFORFAIT
                                },
                                {
                                    type: 'bar',
                                    name: 'Cash-Flow Denormandie Foncier réel',
                                    color: '#efd533',
                                    // barWidth: 20,
                                    data: data_CF_DENORMANDIEREEL
                                },
                                {
                                    type: 'line',
                                    lineStyle: {
                                        width: 3
                                    },
                                    symbolSize: 12,
                                    name: 'Trésorerie cumulée Denormandie Foncier réel',
                                    color: '#efd533',
                                    data: data_TC_DENORMANDIEREEL
                                },
                            ];

                            switch (this.favorite.fiscal_choice) {
                                case 'Foncier forfait':
                                case 'Foncier reel':
                                case 'LMNP forfait':
                                case 'LMNP reel 2025':
                                case 'SCI IS':
                                case 'SCI IR':
                                case 'Societe IS':
                                    this.options_Comp_Treso.legend.selected = {
                                        ['Cash-Flow SCI IS']: true,
                                        ['Trésorerie cumulée SCI IS']: true,
                                        ['Cash-Flow LMP Régime réel']: false,
                                        ['Trésorerie cumulée LMP Régime réel']: false,
                                        ['Cash-Flow LMNP Régime réel']: true,
                                        ['Trésorerie cumulée LMNP Régime réel']: true,
                                        ['Cash-Flow LMNP Micro BIC']: true,
                                        ['Trésorerie cumulée LMNP Micro BIC']: true,
                                        ['Cash-Flow Foncier Régime réel']: true,
                                        ['Trésorerie cumulée Foncier Régime réel']: true,
                                        ['Cash-Flow Foncier Micro foncier']: true,
                                        ['Trésorerie cumulée Foncier Micro foncier']: true,
                                        ['Cash-Flow Denormandie Micro foncier']: false,
                                        ['Trésorerie cumulée Denormandie Micro foncier']: false,
                                        ['Cash-Flow Denormandie Foncier réel']: false,
                                        ['Trésorerie cumulée Denormandie Foncier réel']: false,
                                        ['Cash-Flow Pinel Micro foncier']: false,
                                        ['Trésorerie cumulée Pinel Micro foncier']: false,
                                        ['Cash-Flow Pinel Foncier réel']: false,
                                        ['Trésorerie cumulée Pinel Foncier réel']: false,
                                    };

                                    this.options.legend.selected = {
                                        ['SCI IS']: true,
                                        ['LMP Régime réel']: false,
                                        ['LMNP Régime réel']: true,
                                        ['LMNP Micro BIC']: true,
                                        ['Foncier Régime réel / SCI à l\'IR']: true,
                                        ['Foncier Micro foncier']: true,
                                        ['Denormandie Micro foncier']: false,
                                        ['Denormandie Foncier réel']: false,
                                        ['Pinel Micro foncier']: false,
                                        ['Pinel Foncier réel']: false,
                                    };
                                    break;
                                case 'Denormandie - micro foncier':
                                case 'Denormandie - foncier reel':
                                    this.options_Comp_Treso.legend.selected = {
                                        ['Cash-Flow SCI IS']: true,
                                        ['Trésorerie cumulée SCI IS']: true,
                                        ['Cash-Flow LMP Régime réel']: false,
                                        ['Trésorerie cumulée LMP Régime réel']: false,
                                        ['Cash-Flow LMNP Régime réel']: true,
                                        ['Trésorerie cumulée LMNP Régime réel']: true,
                                        ['Cash-Flow LMNP Micro BIC']: true,
                                        ['Trésorerie cumulée LMNP Micro BIC']: true,
                                        ['Cash-Flow Foncier Régime réel / SCI à l\'IR']: false,
                                        ['Trésorerie cumulée Foncier Régime réel / SCI à l\'IR']: false,
                                        ['Cash-Flow Foncier Micro foncier']: false,
                                        ['Trésorerie cumulée Foncier Micro foncier']: false,
                                        ['Cash-Flow Denormandie Micro foncier']: true,
                                        ['Trésorerie cumulée Denormandie Micro foncier']: true,
                                        ['Cash-Flow Denormandie Foncier réel']: true,
                                        ['Trésorerie cumulée Denormandie Foncier réel']: true,
                                        ['Cash-Flow Pinel Micro foncier']: false,
                                        ['Trésorerie cumulée Pinel Micro foncier']: false,
                                        ['Cash-Flow Pinel Foncier réel']: false,
                                        ['Trésorerie cumulée Pinel Foncier réel']: false,
                                    };

                                    this.options.legend.selected = {
                                        ['SCI IS']: true,
                                        ['LMP Régime réel']: false,
                                        ['LMNP Régime réel']: true,
                                        ['LMNP Micro BIC']: true,
                                        ['Foncier Régime réel / SCI à l\'IR']: false,
                                        ['Foncier Micro foncier']: false,
                                        ['Denormandie Micro foncier']: true,
                                        ['Denormandie Foncier réel']: true,
                                        ['Pinel Micro foncier']: false,
                                        ['Pinel Foncier réel']: false,
                                    };
                                case 'Pinel - foncier reel':
                                case 'Pinel - micro foncier':
                                    this.options_Comp_Treso.legend.selected = {
                                        ['Cash-Flow SCI IS']: true,
                                        ['Trésorerie cumulée SCI IS']: true,
                                        ['Cash-Flow LMP Régime réel']: false,
                                        ['Trésorerie cumulée LMP Régime réel']: false,
                                        ['Cash-Flow LMNP Régime réel']: true,
                                        ['Trésorerie cumulée LMNP Régime réel']: true,
                                        ['Cash-Flow LMNP Micro BIC']: true,
                                        ['Trésorerie cumulée LMNP Micro BIC']: true,
                                        ['Cash-Flow foncier Régime réel / SCI à l\'IR']: true,
                                        ['Trésorerie foncier Régime réel / SCI à l\'IR']: true,
                                        ['Cash-Flow Foncier Micro foncier']: false,
                                        ['Trésorerie cumulée Foncier Micro foncier']: false,
                                        ['Cash-Flow Denormandie Micro foncier']: false,
                                        ['Trésorerie cumulée Denormandie Micro foncier']: false,
                                        ['Cash-Flow Denormandie Foncier réel']: false,
                                        ['Trésorerie cumulée Denormandie Foncier réel']: false,
                                        ['Cash-Flow Pinel Micro foncier']: true,
                                        ['Trésorerie cumulée Pinel Micro foncier']: true,
                                        ['Cash-Flow Pinel Foncier réel']: true,
                                        ['Trésorerie cumulée Pinel Foncier réel']: true,
                                    };

                                    this.options.legend.selected = {
                                        ['SCI IS']: true,
                                        ['LMP Régime réel']: false,
                                        ['LMNP Régime réel']: true,
                                        ['LMNP Micro BIC']: true,
                                        ['Foncier Régime réel']: true,
                                        ['Foncier Micro foncier']: false,
                                        ['Denormandie Micro foncier']: false,
                                        ['Denormandie Foncier réel']: false,
                                        ['Pinel Micro foncier']: true,
                                        ['Pinel Foncier réel']: true,
                                    };
                                case 'LMP - regime reel':
                                    this.options_Comp_Treso.legend.selected = {
                                        ['Cash-Flow SCI IS']: true,
                                        ['Trésorerie cumulée SCI IS']: true,
                                        ['Cash-Flow LMP Régime réel']: true,
                                        ['Trésorerie cumulée LMP Régime réel']: true,
                                        ['Cash-Flow LMNP Régime réel']: true,
                                        ['Trésorerie cumulée LMNP Régime réel']: true,
                                        ['Cash-Flow LMNP Micro BIC']: false,
                                        ['Trésorerie cumulée LMNP Micro BIC']: false,
                                        ['Cash-Flow Foncier Régime réel / SCI à l\'IR']: true,
                                        ['Trésorerie cumulée Foncier Régime réel / SCI à l\'IR']: true,
                                        ['Cash-Flow Foncier Micro foncier']: true,
                                        ['Trésorerie cumulée Foncier Micro foncier']: true,
                                        ['Cash-Flow Denormandie Micro foncier']: false,
                                        ['Trésorerie cumulée Denormandie Micro foncier']: false,
                                        ['Cash-Flow Denormandie Foncier réel']: false,
                                        ['Trésorerie cumulée Denormandie Foncier réel']: false,
                                        ['Cash-Flow Pinel Foncier réel']: false,
                                        ['Trésorerie cumulée Pinel Foncier réel']: false,
                                        ['Cash-Flow Pinel Micro foncier']: false,
                                        ['Trésorerie cumulée Pinel Micro foncier']: false,
                                    };

                                    this.options.legend.selected = {
                                        ['SCI IS']: true,
                                        ['LMP Régime réel']: true,
                                        ['LMNP Régime réel']: true,
                                        ['LMNP Micro BIC']: false,
                                        ['Foncier Régime réel']: true,
                                        ['Foncier Micro foncier']: true,
                                        ['Denormandie Micro foncier']: false,
                                        ['Denormandie Foncier réel']: false,
                                        ['Pinel Micro foncier']: false,
                                        ['Pinel Foncier réel']: false,
                                    };
                            }

                            // Graphique Evolution du capital net
                            const data_CF_cum = [];
                            const data_Amortissement = [];
                            const data_Enrich = [];

                            var cumul = 0;
                            Object.keys(this.result).forEach(keys => {
                                if (parseInt(keys) < this.favorite.duration) {
                                    cumul = cumul + Math.round(this.result[keys].cash_flow);
                                    data_CF_cum.push(cumul);

                                    data_Amortissement.push(Math.round(this.favorite.total_price - this.favorite.apport - this.result[keys].capital_restant_du));
                                    data_Enrich.push(Math.round(this.favorite.total_price - this.favorite.apport - this.result[keys].capital_restant_du) + cumul);
                                }
                            });

                            this.options_Evol_Capital.series = [
                                {
                                    type: 'line',
                                    lineStyle: {
                                        width: 3
                                    },
                                    symbolSize: 12,
                                    name: 'Trésorerie cumulée',
                                    color: '#67C2EF',
                                    data: data_CF_cum
                                },
                                {
                                    type: 'line',
                                    lineStyle: {
                                        width: 3
                                    },
                                    symbolSize: 12,
                                    name: 'Capital remboursé',
                                    color: '#FABB3D',
                                    data: data_Amortissement
                                },
                                {
                                    type: 'line',
                                    lineStyle: {
                                        width: 3
                                    },
                                    symbolSize: 12,
                                    name: 'Enrichissement total',
                                    color: '#78C447',
                                    data: data_Enrich
                                },

                            ];

                            if (this.TriVanInstance) {
                                this.TriVanInstance.setOption(this.options);
                            }
                            if (this.CashFlowInstance) {
                                this.CashFlowInstance.setOption(this.options_CF);
                            }
                            if (this.CompTresoInstance) {
                                this.CompTresoInstance.setOption(this.options_Comp_Treso);
                            }
                            if (this.EvolCapitalInstance) {
                                this.EvolCapitalInstance.setOption(this.options_Evol_Capital);
                            }
                        }
                        this.loading = false;
                    }, err => {
                        console.log(err);
                    });
            }, 1000);
        } else {
            this.loading = false;
        }
    }

    onChartInit(ec) {
        this.TriVanInstance = ec;
    }

    onChartCFInit(ec) {
        this.CashFlowInstance = ec;
    }

    onChartCTInit(ec) {
        this.CompTresoInstance = ec;
    }

    onChartECInit(ec) {
        this.EvolCapitalInstance = ec;
    }

    toFloat(s) {
        return parseFloat(s);
    }
}
